export default {
	permission: window.Notification?.permission,
	windowFocusState: true,
	notifications: [],
	options: {},

	async init() {
		if (!window.Notification) {
			return Promise.reject("not supported Notification");
		}

		if (this.permission === 'default') {
			await Notification.requestPermission();
		}

		if (this.permission === 'granted') {
			const changeWindowFocusState = state => this.windowFocusState = state;
			window.addEventListener('focus', () => { changeWindowFocusState(true) });
			window.addEventListener('blur', () => { changeWindowFocusState(false) });

			return Promise.resolve();
		}
	},
	show(message, options) {
		if (
			this.permission !== 'granted' ||
			this.windowFocusState
		) {
			return;
		}

		const defaultOptions = {
			title: 'Gooroomee Biz',
			limitLength: 1,
			duration: 3000,
		}
		this.options = { ...defaultOptions, ...options };

		while (this.notifications.length >= this.options.limitLength) {
			try{
				const obj = this.notifications.shift();
				obj.close = true;
				if (obj.noti) {
					obj.noti.close();
				}
			} catch(e) {
				console.error(e);
			}
		}

		const obj = {};
		obj.noti = new Notification(this.options.title, {
			body: message
		});

		obj.noti.addEventListener('show', () => { this.onShow(obj) });
		obj.noti.addEventListener('close', () => { this.onClose(obj) });
		obj.noti.addEventListener('click', () => { this.onClick(obj) });

		this.notifications.push(obj.noti);
	},
	onShow(obj) {
		setTimeout(() => {
			this.close(obj)
		}, this.options.duration);
	},
	onClose(obj) {
		this.notifications = this.notifications.filter(item => item !== obj);
	},
	onClick(obj) {
		if (this.options.onclick) {
			this.options.onclick();
		}
		obj.noti.close();
	},
	close(obj) {
		if (!obj.close) {
			return;
		}
		obj.noti.close();
	},
	click(obj) {
		obj.noti.onClick();
	}
}